// Per-variation galleri — byter ut .woocommerce-product-gallery vid variantbyte.
//
// Flödet:
//   1. Vid sidladdning cachas original-galleriets outerHTML.
//   2. På found_variation: om variation.gallery_image_html är icke-tom,
//      ersätt hela .woocommerce-product-gallery och re-initiera WC:s
//      flexslider/photoswipe via $.fn.wc_product_gallery.
//   3. På reset_data: återställ original-galleriet.
//
// Beroende: jQuery + WC:s frontend-scripts (laddas alltid på produktsida).
;(function () {
    if (!window.jQuery) return
    var $ = window.jQuery

    // WooCommerce 10.8:s inbyggda variantbildhantering (wc_variations_image_update)
    // körs också på found_variation och byter ut HUVUDBILDEN (slide 0) mot
    // variantens featured-bild (variation.image). Det här temat har ett eget
    // per-variant-galleri som byter ut HELA galleriet (slides + miniatyrer). WC:s
    // single-image-swap krockar då med vårt: den skriver över slide 0 med en annan
    // bild än den vi lagt in (variantens featured-bild ≠ galleriets första bild),
    // så huvudbilden och miniatyrraden hamnar i osync. Resultatet är att första
    // miniatyren pekar på en redan aktiv slide → den "går inte att klicka på", och
    // huvudbilden kan lämnas blank.
    //
    // Neutralisera WC:s single-image-swap för just de varianter vi äger galleriet
    // för (de har gallery_image_html i variantdatan). WC:s standardbeteende lämnas
    // orört för alla andra produkter/varianter.
    //
    // Anropas både direkt och vid ready: WC:s add-to-cart-variation.js kan laddas
    // efter tema-bundlen, så $.fn.wc_variations_image_update finns inte alltid när
    // IIFE:n körs. Vid ready är alla script parsade.
    function patchWcVariationsImageUpdate() {
        if (!$.fn.wc_variations_image_update || $.fn.__lwVariationGalleryPatched) return
        var _wcVariationsImageUpdate = $.fn.wc_variations_image_update
        $.fn.wc_variations_image_update = function (variation) {
            if (variation && variation.gallery_image_html) {
                return this
            }
            return _wcVariationsImageUpdate.apply(this, arguments)
        }
        $.fn.__lwVariationGalleryPatched = true
    }

    patchWcVariationsImageUpdate()

    var originalGalleryHtml = null

    function captureOriginal() {
        if (originalGalleryHtml !== null) return
        var el = document.querySelector('.woocommerce-product-gallery')
        if (el) originalGalleryHtml = el.outerHTML
    }

    function reinitGallery($gallery) {
        if (typeof $gallery.wc_product_gallery !== 'function') return
        var params = window.wc_single_product_params || {}

        $gallery.trigger('wc-product-gallery-before-init', [$gallery.get(0), params])
        $gallery.wc_product_gallery(params)
        $gallery.trigger('wc-product-gallery-after-init', [$gallery.get(0), params])

        revealGallery($gallery)
    }

    // Markupen har opacity:0 inline (matchar WC:s template) så inget syns förrän vi
    // avslöjar den. Flexslider måste dessutom räkna om viewport-höjden efter att
    // galleriet bytts ut och huvudbilden laddats — annars kan slide 0 lämnas med
    // kollapsad höjd / inaktuell målning (blank huvudbild på ett GPU-kompositlager).
    // WC:s egen galleriswap löser detta genom att trigga ett window-resize kort
    // efter bytet, vilket får flexslider att räkna om och måla om. Vi speglar det,
    // och triggar även en gång till när huvudbilden laddats (ifall den inte hunnit
    // ladda vid första resizen).
    function revealGallery($gallery) {
        $gallery.css('opacity', '')

        // Ett window-resize får flexslider att räkna om viewport-höjden och måla om
        // kompositlagret. Vi triggar över flera frames för att täcka både bildens
        // laddningstid och flexsliders interna debounce — annars kan slide 0 lämnas
        // blank (inaktuell målning på GPU-lagret) trots att DOM:en är korrekt.
        var settle = function () {
            $(window).trigger('resize')
        }
        requestAnimationFrame(settle)
        window.setTimeout(settle, 80)
        window.setTimeout(settle, 300)

        var img = $gallery.find('.woocommerce-product-gallery__image').first().find('img').get(0)
        if (img && !(img.complete && img.naturalWidth > 0)) {
            $(img).one('load', function () {
                requestAnimationFrame(settle)
            })
        }
    }

    // Galleribilderna renderas serverside med loading="lazy". När vi injicerar
    // galleriet via JS efter sidladdning triggas aldrig webbläsarens lazy-load-path
    // tillförlitligt — inte ens för huvudbilden som ligger i viewporten — så slidsen
    // förblir tomma tills en orelaterad reflow råkar väcka dem.
    //
    // Sätts eager INNAN elementen sätts in i DOM:en, så att bilderna laddas som en
    // vanlig eager-bild (precis som container-galleriet gör).
    function forceEagerImages($gallery) {
        $gallery.find('.woocommerce-product-gallery__image img').each(function () {
            this.setAttribute('loading', 'eager')
        })
    }

    function swapGallery(html) {
        if (!html) return
        var $existing = $('.woocommerce-product-gallery').first()
        if (!$existing.length) return

        var $new = $($.parseHTML(html, document, true)).filter('.woocommerce-product-gallery').first()
        if (!$new.length) {
            // Fallback om filter-resultatet inte hittade wrappen (t.ex. om
            // gallery_image_html inte börjar med själva wrappen).
            $new = $('<div>').html(html).find('.woocommerce-product-gallery').first()
        }
        if (!$new.length) return

        forceEagerImages($new)
        $existing.replaceWith($new)
        reinitGallery($new)
    }

    $(function () {
        patchWcVariationsImageUpdate()
        captureOriginal()

        var $forms = $('form.variations_form')
        if (!$forms.length) return

        $forms.on('found_variation', function (event, variation) {
            if (variation && variation.gallery_image_html) {
                swapGallery(variation.gallery_image_html)
            } else if (originalGalleryHtml) {
                // Variant utan eget galleri → fall tillbaka till container.
                swapGallery(originalGalleryHtml)
            }
        })

        $forms.on('reset_data', function () {
            if (originalGalleryHtml) {
                swapGallery(originalGalleryHtml)
            }
        })
    })
})()
